import './styles/Manuals.scss';

import ApplianceDocuments from '../components/appliance/ApplianceDocuments';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query Manuals ($code: String!) {
        productsJson(code: { eq: $code }) {
            code
            id
            documents {
                en_CA
                en_US
                fr_CA
                caption {
                    fr_CA
                    en_CA
                    en_US
                }
            }
            category_localized {
                en_CA
                en_US
                fr_CA
            }
            title {
                en_CA
                en_US
                fr_CA
            }
            fields {
                vuesIPEPImages {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED)
                    }
                }
            }
        }
    }
`;

export default function Manuals({ data } : { data : Queries.ManualsQuery }) {
    const product = data.productsJson;
    const { t } = useTranslation('layout');
    const { currentLocale } = usePageLocalization();

    const applianceCategory = t(
        `categories.${product?.category_localized['en_CA']?.split('/')[3]}`
    );

    return (
        <Layout>
            <SEO
                title={t('metadata:manuals.title', {
                    SKU: product?.code,
                })}
                description={t('metadata:manuals.description', {
                    SKU: product?.code,
                }) as string}
            />
            <div className='manuals-banner-bg'>
                <div className='manuals-banner'>
                    <span className='code'>{product?.code}</span>
                    <h1 className='title'>
                        {applianceCategory.toUpperCase() +
                            ' ' +
                            product?.title[currentLocale]}
                    </h1>

                    <hr />
                </div>
            </div>
            <div className='container manuals'>
                <ApplianceDocuments
                    documents={product?.documents}
                    code={product?.code}
                    vuesIPEP={product?.fields?.vuesIPEPImages}
                    displayIPEP={false}
                    scrollManuals={false}
                />
            </div>
        </Layout>
    );
}
